import * as React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router";
import { DetailLayoutWrapper } from "../../components/sharedStyles";
import DetailPageHeaderMenu from "../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import useActiveFilters from "../../hooks/useActiveFilters";
import { StatusLabel } from "../../components/Lists/Base/CompleteList/styles";
import { PrimaryButton } from "../../components/Forms/Base/Buttons";
import { usePermissionCheck } from "../../store/base";
import CommonAreaModal from "../../components/Forms/CommonArea/ChapterForm/ModalForm";

import { useCommonAreasPaginationCount } from "../../store/commonAreas/hooks/retrieve";
import CommonAreas from "./overview/CommonAreas";
import usePermissionRedirect from "../../hooks/usePermissionRedirect";
import PrimaryBtn from "src/components/Forms/Base/Buttons/PrimaryBtn";

export default function MainCommonAreasOverview() {
  const { path, url } = useRouteMatch();
  const { filteredRealEstates } = useActiveFilters();

  const [createCommonAreaOpen, setCreateCommonAreaOpen] = React.useState(false);
  const canAdd = usePermissionCheck("add_can_baseobject");
  usePermissionRedirect(["view_can_baseobject"]);

  const [activeCount] = useCommonAreasPaginationCount({
    filters: { realestate_ids: filteredRealEstates },
  });

  const SUB_PAGES = [
    {
      path: "/overview",
      label: "Översikt",
      component: CommonAreas,
    },
  ];

  const subPageLinks = SUB_PAGES.map((sp) => ({
    url: `${url}${sp.path}`,
    label: sp.label,
    hasError: sp.hasError,
  }));

  const renderInfoPills = () => {
    return (
      <>
        <StatusLabel state={0}>
          Antal gemensamma ytor:{" "}
          {activeCount != null ? activeCount : "Laddar..."}
        </StatusLabel>
      </>
    );
  };

  const renderActions = () => (
    <>
      {canAdd && (
        <PrimaryBtn onClick={() => setCreateCommonAreaOpen(true)} title="">
          Lägg till gemensam yta
        </PrimaryBtn>
      )}
    </>
  );

  return (
    <>
      {createCommonAreaOpen && (
        <CommonAreaModal
          method="POST"
          onCheckout={() => setCreateCommonAreaOpen(false)}
        />
      )}

      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={`Gemensamma ytor`}
          {...{ subPages: subPageLinks, renderInfoPills, renderActions }}
        />

        <Switch>
          {SUB_PAGES.map((sp) => (
            <Route
              key={sp.path}
              path={`${path}${sp.path}`}
              component={sp.component}
            />
          ))}

          {/* Default sub page  */}
          <Redirect exact to={`${url}${SUB_PAGES[0].path}`} path={`${path}`} />
        </Switch>
      </DetailLayoutWrapper>
    </>
  );
}
